export default __webpack_public_path__ + "static/media/discord.b5bd5243.png";